import {
    type BrandVariants,
    createDarkTheme,
    createLightTheme,
    type Theme,
} from '@fluentui/react-components';

const fiTheme: BrandVariants = {
    10: '#000000',
    20: '#220E03',
    30: '#3B1406',
    40: '#551709',
    50: '#71190A',
    60: '#8E1A09',
    70: '#AC1807',
    80: '#CB1204',
    90: '#EB0200',
    100: '#EE0000',
    110: '#FF603E',
    120: '#FF8261',
    130: '#FF9F83',
    140: '#FFB8A4',
    150: '#FFD1C3',
    160: '#FFE8E2',
};

export const lightTheme: Theme = {
    ...createLightTheme(fiTheme),
};

export const darkTheme: Theme = {
    ...createDarkTheme(fiTheme),
};
